<div class="sidenav">
  <!-- Navigation Section -->
  <span class="nav-heading">
    <mat-icon>menu</mat-icon> Navigation
  </span>
  <ul>
    <li class="no-bottom-border" routerLinkActive="active">
      <a routerLink="/home"  class="companylist active-prf">
        <mat-icon>home</mat-icon> Home 
      </a>
    </li>
    <li class="no-bottom-border" routerLinkActive="active">
      <a routerLink="/dboard"  class="companylist active-prf">
        <mat-icon>view_list</mat-icon> PRF List
      </a>
    </li>
    <li class="no-bottom-border" [ngClass]="{'active': isProgressPage()}">
      <a routerLink="/{{ prfYear }}/{{ prfNumber }}/companyinformation" 
         class="companylist active-prf">
        <mat-icon>bar_chart</mat-icon> Premium Reporting
      </a>
    </li>
  </ul>

  <!-- Reports Section -->
 <span class="reports-heading">
  <mat-icon>assessment</mat-icon> Reports
</span>
<ul>
  <!-- Annual Statement -->
  <ng-container *ngIf="annualstatementCompleted || annualstatementInProgress ; else AnnualDisabled">
    <li routerLinkActive="active">
      <a class="completed" routerLink="/{{ prfYear }}/{{ prfNumber }}/annualstatementcomparison"
        title="Annual Statement Comparison"
      >
        <mat-icon>insert_chart_outlined</mat-icon>
        Annual Statement Co..
      </a>
    </li>
  </ng-container>
  <ng-template #AnnualDisabled>
    <li routerLinkActive="active">
      <a [ngClass]="{disabled: disableAStatementComparison}"
        title="Annual Statement Comparison"
        routerLink="/{{ prfYear }}/{{ prfNumber }}/annualstatementcomparison">
        <mat-icon>insert_chart_outlined</mat-icon>
        Annual Statement Co..
      </a>
    </li>
  </ng-template>

  <!-- Prior Year Comparison -->
  <ng-container *ngIf="priorYearComparisonCompleted || priorYearComparisonInProgress; else PriorDisabled">
    <li routerLinkActive="active">
      <a class="completed" routerLink="/{{ prfYear }}/{{ prfNumber }}/prioryearcomparison"
        title="Prior Year Comparison"
      >
        <mat-icon>calendar_month</mat-icon>
        Prior Year Comparison
      </a>
    </li>
  </ng-container>
  <ng-template #PriorDisabled>
    <li routerLinkActive="active">
      <a [ngClass]="{disabled: disablePriorYearComparison}" 
          routerLink="/{{ prfYear }}/{{ prfNumber }}/prioryearcomparison"
        title="Prior Year Comparison"  
      >
        <mat-icon>calendar_month</mat-icon>
        Prior Year Comparison
      </a>
    </li>
  </ng-template>
   <ng-container *ngIf="isPrfSubmitReport; else PrfSubmitReportDisabled">
    <li routerLinkActive="active">
      <a class="completed" routerLink="/{{ prfYear }}/{{ prfNumber }}/PRFsubmissionreportsummary"
        title="Submission Summary Report"
      >
        <mat-icon>calendar_month</mat-icon>
        Submission Summary..
      </a>
    </li>
  </ng-container>
  <ng-template #PrfSubmitReportDisabled>
    <li routerLinkActive="active">
      <a [ngClass]="{disabled: true}" 
          routerLink="/{{ prfYear }}/{{ prfNumber }}/PRFsubmissionreportsummary"
        title="Submission Summary Report"  
      >
        <mat-icon>calendar_month</mat-icon>
        Submission Summary..
      </a>
    </li>
  </ng-template>
</ul>

  <!-- How this works -->
  <div class="helplink">
    <a (click)="openHelpDocument()">
      <mat-icon>help</mat-icon> <span>How This Works</span>
    </a>
  </div>
</div>
